import { useEffect, useState } from 'react'

import Auth from '@aetosky/auth'
import config from 'config'
import { getCurrentUser } from 'api/auth'
import { setUser } from 'store/authReducer'
import store from 'store/store'

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [isLoading, setIsLoading] = useState(true) // ✅

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const auth = Auth.getInstance({
          baseURL: config.authUrl,
          redirectUri: window.location.origin + config.basename
        });

        let logged = await auth.isLogged()
        if (!logged) {
          logged = await auth.exchangeCodeForToken()
        }
        if (!logged) {
          await auth.redirectToLogin()
        }

        const currentUser = await getCurrentUser()
        store.dispatch(setUser(currentUser))

        if (currentUser.roles['aetos-app'].roles.includes('cube:admin')) {
          setIsAdmin(true)
        }

        setIsAuthenticated(true)
      } catch (error) {
        console.error('Authentication failed:', error)
        setIsAuthenticated(false)
      } finally {
        setIsLoading(false) // ✅ always set done
      }
    }

    verifyAuth()
  }, [])

  return { isAuthenticated, isAdmin, isLoading } // ✅
}


export { useAuth }
